export const checkEmptyFields = (_this) => {
	const val = _this.value;
	
	if ( !_this.classList.contains(`select`) )
	{
		if ( val.length === 0 || !_this.form.querySelector(`input[name="${_this.name}"]:checked`) && ( _this.type === `checkbox` || _this.type === `radio` ) )
		{
			_this.classList.add(`empty`);
			_this.classList.remove(`not-empty`);
			_this.closest(`ul.fields > li`).classList.add(`empty`);
			_this.closest(`ul.fields > li`).classList.remove(`not-empty`);
		} else
		{
			_this.classList.remove(`empty`);
			_this.classList.add(`not-empty`);
			_this.closest(`ul.fields > li`).classList.remove(`empty`);
			_this.closest(`ul.fields > li`).classList.add(`not-empty`);
		}
	}
};
